/* eslint-disable */
const globModules = [
  {
    name: 'tabs',
    loader: () => import('./modules/tabs')
  },
  {
    name: 'header',
    loader: () => import('./modules/header')
  },
  {
    name: 'header-search',
    loader: () => import('./modules/header-search'),
    render: function (Component, nodeList) {
      const React = require('react');
      const { render } = require('react-dom');
      nodeList.forEach(node =>
        render(React.createElement(Component, node.dataset), node)
      );
    }
  },
  {
    name: 'accordion',
    loader: () => import('./modules/accordion')
  },
  {
    name: 'image-video-gallery',
    loader: () => import('./modules/image-video-gallery')
  },
  {
    name: 'pagination-test-module',
    loader: () => import('./modules/pagination-test-module'),
    render: function (Component, nodeList) {
      const React = require('react');
      const { render } = require('react-dom');
      nodeList.forEach(node =>
        render(React.createElement(Component, node.dataset), node)
      );
    }
  },
  {
    name: 'faq-content-toc',
    loader: () => import('./modules/faq-content-toc')
  },
  {
    name: 'home-masthead',
    loader: () => import('./modules/home-masthead')
  },
  {
    name: 'form',
    loader: () => import('./modules/form')
  },
  {
    name: 'table-of-contents',
    loader: () => import('./modules/table-of-contents')
  },
  {
    name: 'data-visual-content',
    loader: () => import('./modules/data-visual-content')
  },
  {
    name: 'course-listing',
    loader: () => import('./modules/course-listing'),
    render: function (Component, nodeList) {
      const React = require('react');
      const { render } = require('react-dom');
      nodeList.forEach(node =>
        render(React.createElement(Component, node.dataset), node)
      );
    }
  },
  {
    name: 'resource-listing',
    loader: () => import('./modules/resource-listing'),
    render: function (Component, nodeList) {
      const React = require('react');
      const { render } = require('react-dom');
      nodeList.forEach(node =>
        render(React.createElement(Component, node.dataset), node)
      );
    }
  },
  {
    name: 'support-areas',
    loader: () => import('./modules/support-areas')
  },
  {
    name: 'profile-preferences',
    loader: () => import('./modules/profile-preferences')
  },
  {
    name: 'areas-of-focus',
    loader: () => import('./modules/areas-of-focus')
  },
  {
    name: 'course-detail',
    loader: () => import('./modules/course-detail')
  },
  {
    name: 'report-a-claim',
    loader: () => import('./modules/report-a-claim'),
    render: function (Component, nodeList) {
      const React = require('react');
      const { render } = require('react-dom');
      nodeList.forEach(node =>
        render(React.createElement(Component, node.dataset), node)
      );
    }
  },
  {
    name: 'multi-step',
    loader: () => import('./modules/multi-step'),
    render: function (Component, nodeList) {
      const React = require('react');
      const { render } = require('react-dom');
      nodeList.forEach(node =>
        render(React.createElement(Component, node.dataset), node)
      );
    }
  },
  {
    name: 'upload-documents',
    loader: () => import('./modules/upload-documents'),
    render: function (Component, nodeList) {
      const React = require('react');
      const { render } = require('react-dom');
      nodeList.forEach(node =>
        render(React.createElement(Component, node.dataset), node)
      );
    }
  },
  {
    name: 'upload-documents-modal',
    loader: () => import('./modules/upload-documents-modal'),
    render: function (Component, nodeList) {
      const React = require('react');
      const { render } = require('react-dom');
      nodeList.forEach(node =>
        render(React.createElement(Component, node.dataset), node)
      );
    }
  },
  {
    name: 'search-results',
    loader: () => import('./modules/search-results'),
    render: function (Component, nodeList) {
      const React = require('react');
      const { render } = require('react-dom');
      nodeList.forEach(node =>
        render(React.createElement(Component, node.dataset), node)
      );
    }
  },
  {
    name: 'rmpc-dashboard',
    loader: () => import('./modules/rmpc-dashboard')
  },
  {
    name: 'policies-dashboard',
    loader: () => import('./modules/policies-dashboard')
  },
  {
    name: 'proresponse-request',
    loader: () => import('./modules/proresponse-request'),
    render: function (Component, nodeList) {
      const React = require('react');
      const { render } = require('react-dom');
      nodeList.forEach(node =>
        render(React.createElement(Component, node.dataset), node)
      );
    }
  },
  {
    name: 'team-members',
    loader: () => import('./modules/team-members'),
    render: function (Component, nodeList) {
      const React = require('react');
      const { render } = require('react-dom');
      nodeList.forEach(node =>
        render(React.createElement(Component, node.dataset), node)
      );
    }
  },
  {
    name: 'member-broker-modal',
    loader: () => import('./modules/member-broker-modal')
  },
  {
    name: 'claims-documents',
    loader: () => import('./modules/claims-documents'),
    render: function (Component, nodeList) {
      const React = require('react');
      const { render } = require('react-dom');
      nodeList.forEach(node =>
        render(React.createElement(Component, node.dataset), node)
      );
    }
  },
  {
    name: 'member-details-wrapper',
    loader: () => import('./modules/member-details-wrapper')
  },
  {
    name: 'clients-listing',
    loader: () => import('./modules/clients-listing'),
    render(Component, nodeList) {
      const React = require('react');
      const { render } = require('react-dom');
      nodeList.forEach(node =>
        render(React.createElement(Component, node.dataset), node)
      );
    }
  },
  {
    name: 'proresponse-dashboard',
    loader: () => import('./modules/proresponse-dashboard')
  },
  {
    name: 'claims-documents',
    loader: () => import('./modules/claims-documents'),
    render: function (Component, nodeList) {
      const React = require('react');
      const { render } = require('react-dom');
      nodeList.forEach(node =>
        render(React.createElement(Component, node.dataset), node)
      );
    }
  },
  {
    name: 'edit-profile-form',
    loader: () => import('./modules/edit-profile-form')
  },
  {
    name: 'clients-listing',
    loader: () => import('./modules/clients-listing')
  },
  {
    name: 'claims-listing',
    loader: () => import('./modules/claims-listing'),
    render(Component, nodeList) {
      const React = require('react');
      const { render } = require('react-dom');
      nodeList.forEach(node =>
        render(React.createElement(Component, node.dataset), node)
      );
    }
  },
  {
    name: 'document-claims-library',
    loader: () => import('./modules/document-claims-library'),
    render(Component, nodeList) {
      const React = require('react');
      const { render } = require('react-dom');
      nodeList.forEach(node =>
        render(React.createElement(Component, node.dataset), node)
      );
    }
  },
  {
    name: 'favorites-listing',
    loader: () => import('./modules/favorites-listing'),
    render(Component, nodeList) {
      const React = require('react');
      const { render } = require('react-dom');
      nodeList.forEach(node =>
        render(React.createElement(Component, node.dataset), node)
      );
    }
  },
  {
    name: 'staff-listing',
    loader: () => import('./modules/staff-listing'),
    render(Component, nodeList) {
      const React = require('react');
      const { render } = require('react-dom');
      nodeList.forEach(node =>
        render(React.createElement(Component, node.dataset), node)
      );
    }
  },
  {
    name: 'primary-contacts',
    loader: () => import('./modules/primary-contacts')
  },
  {
    name: 'tooltip-trigger',
    loader: () => import('./modules/tooltip-trigger')
  },
  {
    name: 'add-member-form',
    loader: () => import('./modules/add-member-form')
  },
  {
    name: 'brokerage-team-listing',
    loader: () => import('./modules/brokerage-team-listing'),
    render(Component, nodeList) {
      const React = require('react');
      const { render } = require('react-dom');
      nodeList.forEach(node =>
        render(React.createElement(Component, node.dataset), node)
      );
    }
  },
  {
    name: 'broker-documents-listing',
    loader: () => import('./modules/broker-documents-listing'),
    render(Component, nodeList) {
      const React = require('react');
      const { render } = require('react-dom');
      nodeList.forEach(node =>
        render(React.createElement(Component, node.dataset), node)
      );
    }
  },
  {
    name: 'attendees-block',
    loader: () => import('./modules/attendees-block')
  },
  {
    name: 'speaker-modal',
    loader: () => import('./modules/speaker-modal')
  },
  {
    name: 'speakers-block',
    loader: () => import('./modules/speakers-block')
  },
  {
    name: 'agenda-accordion',
    loader: () => import('./modules/agenda-accordion')
  },
  {
    name: 'agenda-block',
    loader: () => import('./modules/agenda-block')
  },
  {
    name: 'jumplinks',
    loader: () => import('./modules/jumplinks')
  },
  {
    name: 'archived-newsroom-listing',
    loader: () => import('./modules/archived-newsroom-listing'),
    render: function (Component, nodeList) {
      const React = require('react');
      const { render } = require('react-dom');
      nodeList.forEach(node =>
        render(React.createElement(Component, node.dataset), node)
      );
    }
  },
  {
    name: 'policy-renewal-status-table',
    loader: () => import('./modules/policy-renewal-status-table'),
    render(Component, nodeList) {
      const React = require('react');
      const { render } = require('react-dom');
      nodeList.forEach(node =>
        render(React.createElement(Component, node.dataset), node)
      );
    }
  },
  {
    name: 'progress-bar',
    loader: () => import('./components/progress-bar')
  },
  {
    name: 'rmpc-dashboard-react',
    loader: () => import('./modules/rmpc-dashboard-react'),
    render: function (Component, nodeList) {
      const React = require('react');
      const { render } = require('react-dom');
      nodeList.forEach(node =>
        render(React.createElement(Component, node.dataset), node)
      );
    }
  },
  {
    name: 'rmpc-dashboard-react',
    loader: () => import('./modules/rmpc-dashboard-react'),
    render: function (Component, nodeList) {
      const React = require('react');
      const { render } = require('react-dom');
      nodeList.forEach(node =>
        render(React.createElement(Component, node.dataset), node)
      );
    }
  },
  {
    name: 'rmpc-dashboard-redesign-react',
    loader: () => import('./modules/rmpc-dashboard-redesign-react'),
    render: function (Component, nodeList) {
      const React = require('react');
      const { render } = require('react-dom');
      nodeList.forEach(node =>
        render(React.createElement(Component, node.dataset), node)
      );
    }
  },
  {
    name: 'event-listing',
    loader: () => import('./modules/event-listing'),
    render: function (Component, nodeList) {
      const React = require('react');
      const { render } = require('react-dom');
      nodeList.forEach(node =>
        render(React.createElement(Component, node.dataset), node)
      );
    }
  },
  {
    name: 'registration-form-block',
    loader: () => import('./modules/registration-form-block')
  }
];

export default globModules;
